import React, {useMemo, useRef} from 'react';
import {
    Content,
    MobileAirportCode,
    MobileAirportIcon,
    MobileAirportItem,
    MobileAirportLabel,
    MobileAirportName,
    MobileSectionLabel,
    MultiDestinationBtn,
    NameContent,
    NameWrapper,
    SearchBox,
    SearchIcon,
    SearchInput,
    SearchItem,
    SectionTitle
} from "./styles";
import {StyledParagraph, StyledText, StyledTitle} from "../CustomAntdComponents/Typography";
import {useStore} from "../../store/global/appStore";
import {SuggestionType} from "./index";
import { FixedSizeList as List } from 'react-window';
import { ReactComponent as FlightIcon } from "../../assets/images/flight-takeoff.svg";
import { ReactComponent as FlightLandIcon } from "../../assets/images/flight-land.svg";
import { Global } from '@solar-icons/react';
import { ClockCircleOutlined, RightOutlined } from '@ant-design/icons';

const suggestedSearches: SuggestionType[] = [
    {
        name: "Nairobi, Kenya",
        label: "Jomo Kenyatta International Airport",
        code: "NBO",
        value: "NBO",
    },
    {
        name: "Nairobi, Kenya",
        label: "Wilson Airport",
        code: "WIL",
        value: "WIL",
    },
     {
        name: "Mombasa, Kenya",
        label: "Moi International Airport",
        code: "MBA",
        value: "MBA",
    },
    {
        name: "Lagos, Nigeria",
        label: "Murtala Muhammed International Airport",
        code: "LOS",
        value: "LOS"
    },
    {
        name: "Kisumu, Kenya",
        label: "Kisumu International Airport",
        code: "KIS",
        value: "KIS",
    },
    {
        name: "Eldoret, Kenya",
        label: "Eldoret International Airport",
        code: "EDL",
        value: "EDL",
    },
    {
        name: "Diani / Ukunda, Kenya",
        label: "Ukunda Airport",
        code: "UKA",
        value: "UKA",
    },
    {
        name: "London, England",
        label: "London Heathrow Airport",
        code: "LHR",
        value: "LHR"
    },
    {
        name: "Zanzibar, Tanzania",
        label: "Abeid Amani Karume International Airport",
        code: "ZNZ",
        value: "ZNZ",
    },
    {
        name: "Entebbe, Uganda",
        label: "Entebbe International Airport",
        code: "EBB",
        value: "EBB",
    },
    {
        name: "Toronto, Canada",
        label: "Toronto Pearson International Airport",
        code: "YYZ",
        value: "YYZ"
    },
    {
        name: "Abuja, Nigeria",
        label: "Nnamdi Azikiwe International Airport",
        code: "ABV",
        value: "ABV"
    }
];

const SelectSearches = ({
    onSelect,
    searchText,
    setSearchText,
    height = 500,
    limitSuggestionHeight,
    mode,
    disabled = false,
    allowMultipleDestinations = false,
    onAddMultipleDestinations,
    setIsOpen,
    isMobileView=false,
    showTitle = true,
}: {
        limitSuggestionHeight?: boolean,
        height?: number,
        onSelect: (airport: string) => void;
        searchText: string;
        setSearchText: (value: string) => void;
        mode: string;
        disabled?: boolean,
        allowMultipleDestinations?: boolean,
        onAddMultipleDestinations?: () => void;
        setIsOpen?: (isOpen: boolean) => void;
        isMobileView?: boolean;
        showTitle?: boolean;
}) => {
      const searchRef = useRef<HTMLInputElement>(null);
    
    
    
    const isFrom = mode === "from";
  const popoverTitle = isFrom
    ? "Where are you departing from?"
    : "Where is your destination?";
    const { airports } = useStore();
    const airportsList = airports;

    const filteredOptions = useMemo(() => {
        const textLower = searchText.toLowerCase();
        return airportsList.filter((option) => {
            const concatenatedFields = `${option?.Code} ${option?.StateName} ${option?.StateCode} ${option?.Name}`.toLowerCase();
            return concatenatedFields.includes(textLower);
        });
    }, [airportsList, searchText]);

    const filteredLength = filteredOptions.length
    const suggestionHeight = limitSuggestionHeight ? `${height}px` : "100%";
    const listHeight = limitSuggestionHeight ? height - 48 : height;


    return (
        <Content
            height={suggestionHeight}
            className={isMobileView ? "mobile-route-selector-content" : undefined}
        >
            {showTitle && (
              <SectionTitle>
                <StyledText size="16px">{popoverTitle}</StyledText>
              </SectionTitle>
            )}

            {isMobileView && (
                <SearchBox className="mobile-route-search-box">
                <SearchIcon className="mobile-route-search-icon">
                {isFrom ? <FlightIcon /> : <FlightLandIcon />}
                </SearchIcon>

                <SearchInput
                className="mobile-route-search-input"
                ref={searchRef}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder={isFrom ? "From:" : "To:"}
                aria-label={isFrom ? "Search departure airport" : "Search destination airport"}
                />
                </SearchBox>
            )}
            {searchText && filteredLength === 0 && (
                <SectionTitle>
                <StyledParagraph align="center" size="normal">
                    No results found.
                </StyledParagraph>
                </SectionTitle>
            )}

            {searchText ? (
                isMobileView ? (
                    <>
                    {filteredOptions.map((option) => (
                        <MobileAirportItem
                            type="button"
                            key={option.Code}
                            onClick={() => onSelect(option.Code)}
                        >
                            <MobileAirportIcon>
                                {isFrom ? <FlightIcon /> : <FlightLandIcon />}
                            </MobileAirportIcon>
                            <span>
                                <MobileAirportName>
                                    {`${option.StateCode}, ${option.StateName}`}
                                </MobileAirportName>
                                <MobileAirportLabel>{option.Name}</MobileAirportLabel>
                            </span>
                            <MobileAirportCode>{option.Code}</MobileAirportCode>
                        </MobileAirportItem>
                    ))}
                    </>
                ) : (
                <List
                height={listHeight}
                itemCount={filteredOptions.length}
                itemSize={66}
                width="100%"
                >
                {({ index, style }) => {
                    const option = filteredOptions[index];

                    return (
                    <div
                        style={{
                            ...style,
                            paddingLeft: isMobileView ? 0 : "16px",
                            paddingRight: isMobileView ? 0 : "16px",
                        }}
                    >
                        <SearchItem onClick={() => onSelect(option.Code)}>
                        <NameWrapper>
                            <NameContent>
                            <StyledTitle level={5}>
                                {`${option.StateCode}, ${option.StateName}`}
                            </StyledTitle>
                            <StyledText>{option.Name}</StyledText>
                            </NameContent>
                        </NameWrapper>
                        <StyledTitle level={4}>{option.Code}</StyledTitle>
                        </SearchItem>
                    </div>
                    );
                }}
                </List>
                )
            ) : (
                <>
                {isMobileView ? (
                    <>
                    {!isFrom && allowMultipleDestinations && (
                        <MultiDestinationBtn
                        type="button"
                        onClick={() => {
                            onAddMultipleDestinations?.();
                            setIsOpen?.(false);
                        }}
                        >
                        <Global />
                        Add multiple destinations
                        </MultiDestinationBtn>
                    )}

                    <MobileSectionLabel>Near you</MobileSectionLabel>
                    {suggestedSearches.map((search) => (
                        <MobileAirportItem
                            type="button"
                            key={search.value}
                            onClick={() => onSelect(search.value)}
                        >
                            <MobileAirportIcon>
                                {isFrom ? <FlightIcon /> : <FlightLandIcon />}
                            </MobileAirportIcon>
                            <span>
                                <MobileAirportName>{search.name}</MobileAirportName>
                                <MobileAirportLabel>{search.label}</MobileAirportLabel>
                            </span>
                            <MobileAirportCode>{search.code}</MobileAirportCode>
                        </MobileAirportItem>
                    ))}
                    </>
                ) : (
                    <>
                    {!isFrom && allowMultipleDestinations && (
                    <MultiDestinationBtn
                    type="button"
                    onClick={() => {
                        onAddMultipleDestinations?.();
                        setIsOpen?.(false);
                    }}
                    >
                    <Global />
                    Add multiple destinations
                    </MultiDestinationBtn>
                    )}

                    {suggestedSearches.map((search, index) => (
                    <SearchItem key={index} onClick={() => onSelect(search.value)}>
                    <NameWrapper>
                        <NameContent>
                        <StyledTitle level={5}>{search.name}</StyledTitle>
                        <StyledText>{search.label}</StyledText>
                        </NameContent>
                    </NameWrapper>
                    {search?.code && <StyledTitle level={4}>{search.code}</StyledTitle>}
                    </SearchItem>
                    ))}
                    </>
                )}
                </>
            )}
        </Content>
    )
};



export default SelectSearches;
